import { Component, OnInit, signal } from "@angular/core";

import { FormsModule } from "@angular/forms";
import { Router, RouterLink } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { finalize } from "rxjs";
import { VerifyCodeComponent } from "../verify-code/verify-code.component";
import { IApiError } from "../../../Utils/_interceptors/network-error.model";
import { AccountService } from "../../../Utils/_services/account/account.service";
import { LeftUiTemplateComponent } from "../left-ui-template/left-ui-template.component";

@Component({
  selector: "app-forgot",
  standalone: true,
  imports: [FormsModule, VerifyCodeComponent, LeftUiTemplateComponent, RouterLink],
  templateUrl: "./forgot.component.html",
  styleUrl: "./forgot.component.css",
})
export class ForgotComponent implements OnInit {
  constructor(
    private accountService: AccountService,
    private router: Router,
    private toastr: ToastrService
  ) { }

  year = signal(new Date().getFullYear());
  public forgotModel = {
    usernameOrEmail: "",
  };
  public isLoading = signal(false);
  public errorMessage = signal("");
  emailSent = signal(false);
  ngOnInit(): void { }

  onSubmit(): void {
    if (this.isLoading()) return;

    if (!this.forgotModel.usernameOrEmail) {
      this.errorMessage.set("Please enter your username or email.");
      return;
    }

    this.isLoading.set(true);
    this.errorMessage.set("");

    this.accountService
      .forgot({ email: this.forgotModel.usernameOrEmail })
      .pipe(finalize(() => this.isLoading.set(false)))
      .subscribe({
        next: res => {
          if (res.data.emailSent) {
            this.router.navigate(["/auth/forgot-password-otp"], {
              state: {
                email: this.forgotModel.usernameOrEmail,
                resetExpireTime: res.data.resetExpireTime
              }
            });
            this.toastr.info("Verification code sent to your email");
          }
        },
        error: (err: IApiError) => {
          this.toastr.info(err?.message);
        },
      });
  }

  navigateToLogin(): void {
    this.router.navigate(["/auth/login"]);
  }

  clearError(): void {
    this.errorMessage.set("");
  }
}
